import axios from "axios";
import store from "@/store";

export const baseUrl = "/compliance-server/api";

export const http = axios.create({
  headers: { "Content-type": "application/json" },
  baseURL: baseUrl,
});

function getAccessToken() {
  return store.state.keycloak?.token;
}

http.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
